




















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
  fontFaceList,
  predefineColors,
  formAddList,
  shortFormAddList,
  countdownTimeOption,
  borderRadiusOptions,
  borderStyleOptions,
  typesettingOptions,
  typesettingOptions1,
  typesettingOptionsLeftRightOnly,
  fontSizeOptions,
  fontSizeSmallOptions,
  backgroundOptions,
  containerBorderRadiusOptions,
  POP_WINDOW_WHEEL_TYPE,
} from '../../../constant/options';
import YcColorPicker from '@/components/color-picker/index.js';
import compontentForm from '@/views/wheelOfFortune/components/form.vue';
import { PopSettingsVO, TFormSaveDetailRequest } from '@/model/FormWheel';
import ExtendedCountdownSetting from '@/components/wheel/extendedCountdown/ExtendedCountdownSetting.vue';
import {
  ensureExtendedCountdownIfNeeded as ensureExtCountdownSettings,
  syncLegacyCountDownFromExtFixedDuration
} from '@/components/wheel/extendedCountdown/extendedCountdownModel';
import { EXT_COUNTDOWN_FIXED_DURATION_DEFAULT_SECONDS } from '@/components/wheel/extendedCountdown/extendedCountdownPresets';
import discountDialog from '@/views/wheelOfFortune/components/discountDialog.vue';
import EventBus from '@/utils/eventBus';
import { getFontFaceList } from '@/utils/getFontFaceList';
import TextAlignPicker from '@/components/text-align/index.vue';
import WheelOptionsCollapse from './WheelOptionsCollapse.vue';
import FontPicker from '@/components/FontPicker/index.vue';
import ImageLibraryDialog from './ImageLibraryDialog.vue';
import { getVueAppUploadApi } from '@/services/util';
import { isEnableExtendedPopCountdown, DISABLE_SMS_SUBSCRIPTION_TPLID, isEnableAuth, isEnableCloseButtonAdvanced,isEnableFontPicker, isEnableFlowTfnSend, isEnablePrivacySetting, isEnableSmsDoubleCheck, isEnableWheelCouponSetting, isEnableOnlyNewUserCustomStep, isOnlyNewUserTemplate,isEnableImageLibrary } from '@/utils/experiment';
import CustomWheelEditor from './CustomWheelEditor.vue';
import CloseButtonSetting from './CloseButtonSetting.vue';
import { getQueryVariable, getImageList } from '@/services/api';
import { isCustomStepLimitExcludedForm, isEmailPhoneStepForm } from '../../utils/stepPages';
import CollapseArrow from './CollapseArrow.vue';

@Component({
  components: {
    'yc-color-picker': YcColorPicker,
    'compontent-form': compontentForm,
    discountDialog: discountDialog,
    'text-align-picker': TextAlignPicker,
    WheelOptionsCollapse,
    CloseButtonSetting,
    ImageLibraryDialog,
    CustomWheelEditor,
    'font-picker': FontPicker,
    CollapseArrow,
    'extended-countdown-setting': ExtendedCountdownSetting
  }
})
export default class wheelOfFortuneTextStart extends Vue {
  @Prop(Object)
  formData!: TFormSaveDetailRequest<PopSettingsVO>;

  @Prop(Number)
  triggerEventType!: any;

  @Prop(Array)
  countryList!: any;

  @Prop(Array)
  pageSettings!: any[];

  formDataStart: TFormSaveDetailRequest<PopSettingsVO> = this.formData;
  formList = this.formData.settings?.start || [];

  // popWindowWheel=2：弹窗设置按“侧图”逻辑展示
  get isPopWheelCombo2() {
    return Number(this.formDataStart?.popWindowWheel) === 2;
  }

  // 选择框选项
  get formAddList() {
    if (this.formData.settings.combinationType == 2) {
      return formAddList.filter(item => {
        if (item.label != 'Email') {
          return item;
        }
      });
    } else {
      return formAddList;
    }
  }
  shortFormAddList = shortFormAddList;
  countdownTimeOption = countdownTimeOption;
  predefineColors = predefineColors;
  fontFaceList = getFontFaceList(fontFaceList);
  borderRadiusOptions = borderRadiusOptions;
  borderStyleOptions = borderStyleOptions;
  typesettingOptions = typesettingOptions;
  fontSizeOptions = fontSizeOptions;
  fontSizeSmallOptions = fontSizeSmallOptions;
  backgroundOptions = backgroundOptions;
  typesettingOptions1 = typesettingOptions1;
  typesettingOptionsLeftRightOnly = typesettingOptionsLeftRightOnly;
  containerBorderRadiusOptions = containerBorderRadiusOptions;

  countdownTime: string = 'minute';
  countDown: number = 5;
  collapseArr = ['1', '2'];
  formStyleCollapseArr = ['inputStyle', 'optionStyle', 'dropdownStyle', 'privacyStyle'];
  emailOpen: boolean = this.formData.settings.rules.emailOpen === true && this.formData.settings.rules.emailPosition === 'start';
  couponCodeShow: boolean = this.formData.settings.rules.couponCodeShow === true && this.formData.settings.rules.couponCodePosition === 'start';
  compontentFormIsShow = false;
  formType = {};

  uploadUrl = getVueAppUploadApi() + '/upload/formImage';
  uploadDialogVisible = false;
  uploadDialogUrl = '';

  bgUploadFileList: { name: string; url: string }[] = [];
  bgUploadShow = false;
  logoUploadFileList: { name: string; url: string }[] = [];
  logoUploadShow = false;
  leftAdImageFileList: { name: string; url: string }[] = [];
  leftAdImageShow = false;
  rightAdImageFileList: { name: string; url: string }[] = [];
  rightAdImageShow = false;
  textAreaUploadShow = false;
  textAreaFileList: { name: string; url: string }[] = [];

  zpbgUploadFileList: { name: string; url: string }[] = [];
  zpbgUploadShow = false;
  pointUploadFileList: { name: string; url: string }[] = [];
  pointUploadShow = false;

  showDiscountDialog = false;

  // 自定义转盘
  customWheelDialogVisible = false;
  customWheelConfig: any = null;

  // 素材库相关状态
  backgroundImageDialogVisible = false;
  wheelImageDialogVisible = false;
  pointerImageDialogVisible = false;

  backgroundImageList: { id: number, imageName: string, imageUrl: string }[] = [];
  wheelImageList: { id: number, imageName: string, imageUrl: string }[] = [];
  pointerImageList: { id: number, imageName: string, imageUrl: string }[] = [];

  selectBackgroundImageUrl: string = '';
  selectWheelImageUrl: string = '';
  selectPointerImageUrl: string = '';

  get customWheelConfigValue() {
    const settings: any = (this.formDataStart as any).settings || {};
    return settings.wheelImageConfig || this.customWheelConfig;
  }

  openCustomWheel() {
    this.customWheelDialogVisible = true;
    const settings: any = (this.formDataStart as any).settings || {};
    const typesetting = settings.typesetting || {};

    // 优先使用弹窗配置中已保存的自定义转盘配置
    if (settings.wheelImageConfig) {
      this.customWheelConfig = settings.wheelImageConfig;
    }

    const bgUrl: string | undefined =
      typesetting.imgUrl || typesetting.bgImgUrl;

    if (bgUrl) {
      const prev = this.customWheelConfig || {};
      this.customWheelConfig = {
        ...prev,
        size: {
          ...(prev.size || {}),
          backgroundImageUrl: bgUrl
        }
      };
    }
  }

  onCustomWheelConfirm(url: string, config: any) {
    const settings: any = (this.formDataStart as any).settings || {};
    settings.typesetting = settings.typesetting || {};
    settings.typesetting.imgUrl = url;

    // 保存配置到弹窗配置中，供下次优先使用
    settings.wheelImageConfig = config;

    this.customWheelConfig = config;
    this.bgUploadFileList = url ? [{ name: '', url }] : [];
    this.changeStart();
  }

  onCustomWheelCancel() {
    this.customWheelDialogVisible = false;
  }

  // 素材库图片选择处理方法
  // 选择背景图
  handleSelectBackgroundImage(selectedUrl?: string) {
    if (typeof selectedUrl === 'string') {
      this.selectBackgroundImageUrl = selectedUrl;
    }
    const typesetting = this.formDataStart?.settings?.typesetting;
    if (this.selectBackgroundImageUrl && typesetting) {
      this.$set(typesetting, 'bgImgUrl', this.selectBackgroundImageUrl);
      this.zpbgUploadShow = true;
      this.zpbgUploadFileList = [{ name: '', url: this.selectBackgroundImageUrl }];
      this.changeStart();
    }
    this.backgroundImageDialogVisible = false;
  }

  // 选择转盘图
  handleSelectWheelImage(selectedUrl?: string) {
    if (typeof selectedUrl === 'string') {
      this.selectWheelImageUrl = selectedUrl;
    }
    const typesetting = this.formDataStart?.settings?.typesetting;
    if (this.selectWheelImageUrl && typesetting) {
      if (Number(this.formDataStart.popWindowWheel) === 2) {
        // 转盘组合布局沿用上传逻辑，同时写入 wheelImgUrl / bgImgUrl。
        this.$set(typesetting, 'wheelImgUrl', this.selectWheelImageUrl);
        this.$set(typesetting, 'bgImgUrl', this.selectWheelImageUrl);
        this.zpbgUploadShow = true;
        this.zpbgUploadFileList = [{ name: '', url: this.selectWheelImageUrl }];
      } else {
        // 普通小转盘预览读取 imgUrl，素材库选择需要与上传入口保持一致。
        this.$set(typesetting, 'imgUrl', this.selectWheelImageUrl);
        this.bgUploadShow = true;
        this.bgUploadFileList = [{ name: '', url: this.selectWheelImageUrl }];
      }
      this.changeStart();
    }
    this.wheelImageDialogVisible = false;
  }

  // 选择指针图
  handleSelectPointerImage(selectedUrl?: string) {
    if (typeof selectedUrl === 'string') {
      this.selectPointerImageUrl = selectedUrl;
    }
    const typesetting = this.formDataStart?.settings?.typesetting;
    if (this.selectPointerImageUrl && typesetting) {
      this.$set(typesetting, 'pointImgUrl', this.selectPointerImageUrl);
      this.pointUploadShow = true;
      this.pointUploadFileList = [{ name: '', url: this.selectPointerImageUrl }];
      this.changeStart();
    }
    this.pointerImageDialogVisible = false;
  }

  // 第三方登录提供商配置
  authProviders = [
    {
      type: 2,
      name: 'Google',
      label: 'Sign in with Google',
      icon: require('@/assets/img/auth/google.svg'),
      placeholder: '请输入 Google Client ID'
    }
  ];

  // wheelOptionsCollapse同步
  onWheelOptionsChange(list: any[]) {
    console.log('onWheelOptionsChange', list);
    this.formDataStart.settings.discountList = list;
    this.changeStart();
  }

  get enableAuth() {
    const tid = `${Number(this.$route.query.templateid) || this.formData.templateId}`;
    const triggerEventType = this.formData.triggerEventType;
    const hasEmail = this.formData.settings.start?.find(item => item.type === 'Email');
    return isEnableAuth() && hasEmail && (
      (triggerEventType === 2 && tid === '98') ||
      (triggerEventType === 0 && this.formData.type === 'POP_WINDOW')
    );
  }

  get enableFormOptimize() {
    return true;
  }

  get enableCloseButtonAdvanced() {
    return isEnableCloseButtonAdvanced();
  }

  handleCloseButtonChange(config: any) {
    // 同步更新老的 closeColor 以保持兼容
    if (config && config.iconColor) {
      this.formDataStart.settings.rules.closeColor = config.iconColor;
    }
    this.changeStart();
    window?.gtagClick?.('form_edit_setCloseButton', '弹窗_编辑订阅工具_设置关闭按钮');
  }

  get enableWheelCouponSetting() {
    return (
      isEnableWheelCouponSetting() &&
      this.formDataStart.settings.discountList &&
      [1, 2].includes(Number(this.formDataStart.popWindowWheel))
    );
  }

  get enableOnlyNewUserCustomStep() {
    const templateId = String(getQueryVariable('templateid') || this.formDataStart?.templateId || '');
    return isEnableOnlyNewUserCustomStep() && isOnlyNewUserTemplate(templateId);
  }

  get enableImageLibrary() {
    return isEnableImageLibrary() && this.isPopZhuanpan;
  }
  
  // SKA2792: templateId===206 阶梯折扣固定模板——步骤一采集项固定为邮箱,不可新增/删除/修改
  // SKA2792: templateId===210 阶梯折扣固定模板——步骤一采集项固定为邮箱,不可新增/删除/修改
  get isTieredDiscountTemplate() {
    const templateId = String(getQueryVariable('templateid') || this.formDataStart?.templateId || '');
    return templateId === '210';
  }

  ensureTieredDiscountButtonAction() {
    if (this.isTieredDiscountTemplate && this.formDataStart?.settings?.rules?.buttonAction !== 'open') {
      this.$set(this.formDataStart.settings.rules, 'buttonAction', 'open');
    }
  }

  get useShortFormAddList() {
    return !this.stepDisplayDisabled || this.isPopZhuanpan || this.customStepLimitExcluded || this.triggerEventType === 7 || this.enableOnlyNewUserCustomStep;
  }

  get customStepLimitExcluded() {
    return isCustomStepLimitExcludedForm(this.formDataStart, getQueryVariable('templateid') || this.formDataStart?.templateId);
  }

  get enablePrivacySetting() {
    return isEnablePrivacySetting();
  }

  get enableInputFontFamily() {
    return true;
  }

  get enableFontPicker() {
    return isEnableFontPicker();
  }

  /** AB：扩展倒计时配置面板与 `settings.countdown` 下发 */
  get enableExtendedPopCountdown() {
    return isEnableExtendedPopCountdown();
  }

  /** 未命中 AB 时始终展示旧版区域；命中 AB 时仅当 `countDownShowLegacyUi === true` 展示 */
  get showLegacyCountdownUiFields() {
    if (!this.enableExtendedPopCountdown) return true;
    return this.formDataStart.settings.rules.countDownShowLegacyUi === true;
  }

  get legacyCountdownUiSwitch(): boolean {
    return this.formDataStart.settings.rules.countDownShowLegacyUi === true;
  }

  set legacyCountdownUiSwitch(v: boolean) {
    Vue.set(this.formDataStart.settings.rules, 'countDownShowLegacyUi', v);
    if (v && this.enableExtendedPopCountdown) {
      this.countdownTime = 'minute';
      this.countDown = 5;
      this.ensureExtendedCountdownIfNeeded();
      const cd = this.formDataStart.settings.countdown;
      if (cd?.rules?.type === 'fixed_duration' && cd.rules.duration) {
        const d = cd.rules.duration;
        Vue.set(d, 'days', 0);
        Vue.set(d, 'hours', 0);
        Vue.set(d, 'minutes', 5);
        Vue.set(d, 'seconds', 0);
        syncLegacyCountDownFromExtFixedDuration(this.formDataStart.settings);
      } else {
        Vue.set(this.formDataStart.settings.rules, 'countDown', EXT_COUNTDOWN_FIXED_DURATION_DEFAULT_SECONDS);
      }
    }
    this.changeStart();
  }

  ensureExtendedCountdownIfNeeded() {
    ensureExtCountdownSettings(this.formDataStart.settings, {
      hasTemplateIdInUrl: !!this.$route.query.templateid
    });
  }

  get enableSubscribeDifferentPage() {
    return this.formDataStart.successPageType === 1
  }

  get enableMobileRatio() {
    return true;
  }

  get enableCustomWheelImage() {
    const tid = `${Number(this.$route.query.templateid) || this.formData.templateId}`;
    return tid === '188';
  }

  get enableSmsSubscription() {
    const templateId = String(getQueryVariable('templateid') || this.formDataStart?.templateId || '');
    // 当时是表单最后一步时，才支持短信订阅
    const hasMiddlePage = this.pageSettings.some((item: any) => item.value === 'middle');
    return !hasMiddlePage && isEnableFlowTfnSend() && !DISABLE_SMS_SUBSCRIPTION_TPLID.includes(templateId) && this.triggerEventType !== 7;
  }

  get showSmsCoiSwitch() {
    return isEnableSmsDoubleCheck();
  }

  get company33aPopDisable() {
    const disablePop =
      (JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id == 33 && this.formData?.id == '55abadf02473424aa42004745e4b74f6') ||
      (JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id == 30 && this.formData?.id == '8eaf5e5c7d244b65bc9843e98f33d08d');
    return disablePop;
  }

  get companyis535() {
    const status = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id === 535;
    return status;
  }

  get shopType() {
    const companyInfo = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    if (companyInfo.shop) {
      if (companyInfo.shop.includes('shopify')) {
        return `shopify`;
      } else if (companyInfo.shop.includes('shopline')) {
        return `shopline`;
      }
    }
    if (companyInfo.integrationType) {
      return companyInfo.integrationType?.toLowerCase();
    }
    return ``;
  }

  get hasMiddlePage() {
    return this.pageSettings.find((item: any) => item.value === 'middle') !== undefined;
  }

  get formStyle() {
    const rules = this.formDataStart.settings.rules;
    const styleMap = this.formDataStart.settings.styles.styleMap;
    const textAlignMap: Record<string, string> = {
      'left': 'flex-start',
      'center': 'center',
      'right': 'flex-end',
    };
    const optionColumns = Math.max(1, Math.min(3, Number(rules.optionColumns || 1)));
    const optionColumnGap = 16;
    const optionFlexBasis = optionColumns === 1 ? '100%' : 'auto';

    console.log('formStyle', rules, styleMap);
    return `
      .cartx-form[data-form-type="options"] {
        margin-top: ${(rules.optionMarginTop ?? 0)}px !important;
        margin-bottom: ${(rules.optionMarginBottom ?? 14)}px !important;
        margin-left: ${(rules.optionMarginLeft ?? 0)}px !important;
        margin-right: ${(rules.optionMarginRight ?? 0)}px !important;
      }
      .cartx-form[data-form-type="input"] {
        margin-top: ${(rules.inputMarginTop ?? 0)}px !important;
        margin-bottom: ${(rules.inputMarginBottom ?? 14)}px !important;
        margin-left: ${(rules.inputMarginLeft ?? 0)}px !important;
        margin-right: ${(rules.inputMarginRight ?? 0)}px !important;
      }
      .cartx-form[data-form-type="dropdown"] {
        margin-top: ${(rules.dropdownMarginTop ?? 0)}px !important;
        margin-bottom: ${(rules.dropdownMarginBottom ?? 14)}px !important;
        margin-left: ${(rules.dropdownMarginLeft ?? 0)}px !important;
        margin-right: ${(rules.dropdownMarginRight ?? 0)}px !important;
      }
      .cartx-question-option-list {
        display: flex !important;
        flex-wrap: wrap !important;
        column-gap: ${optionColumnGap}px !important;
        row-gap: 8px !important;
        text-align: left !important;
      }
      .cartx-option-columns:not(.cartx-privacy){
        min-width: 0 !important;
        max-width: 100% !important;
        flex: 0 0 ${optionFlexBasis} !important;
        margin: 0 !important;
        color: ${rules.optionTextColor || rules.optionColor}!important;
        display: inline-flex !important;
        align-items: center !important;
        white-space: normal !important;
        ${rules.optionFontFamily ? `font-family: ${rules.optionFontFamily} !important;` : ''}
        ${rules.optionFontSize ? `font-size: ${rules.optionFontSize} !important;` : ''}
      }
      .cartx-option-columns:not(.cartx-privacy) .el-checkbox__input,
      .cartx-option-columns:not(.cartx-privacy) .el-radio__input {
        display: inline-flex !important;
        align-items: center !important;
      }
      .cartx-option-columns:not(.cartx-privacy) .el-checkbox__label,
      .cartx-option-columns:not(.cartx-privacy) .el-radio__label {
        color: ${rules.optionTextColor || rules.optionColor}!important;
        display: inline-flex !important;
        align-items: center !important;
        line-height: 1.2 !important;
        ${rules.optionFontFamily ? `font-family: ${rules.optionFontFamily} !important;` : ''}
        ${rules.optionFontSize ? `font-size: ${rules.optionFontSize} !important;` : ''}
      }
      .cartx-option-columns:not(.cartx-privacy):not(:last-child) {
        margin-bottom: 0 !important;
      }
      .cartx-option-columns:not(.cartx-privacy) .el-checkbox__inner,
      .cartx-option-columns:not(.cartx-privacy) .el-radio__inner {
        border-color: #C5C4CE !important;
      }
      .cartx-option-columns:not(.cartx-privacy) .el-checkbox__input.is-checked .el-checkbox__inner,
      .cartx-option-columns:not(.cartx-privacy) .el-radio__input.is-checked .el-radio__inner {
        border-color: ${rules.optionTextColor || rules.optionColor}!important;
      }
      .cartx-option-columns:not(.cartx-privacy) .el-checkbox__input.is-checked .el-checkbox__inner,
      .cartx-option-columns:not(.cartx-privacy) .el-radio__input.is-checked .el-radio__inner {
        border-color: ${rules.optionBackground}!important;
        background: ${rules.optionBackground}!important;
      }
      .cartx-question:not(.cartx-dropdown-title) {
        color: ${rules.optionTitleColor || rules.optionColor}!important;
        ${rules.optionFontFamily ? `font-family: ${rules.optionFontFamily} !important;` : ''}
        ${rules.optionTitleFontSize ? `font-size: ${rules.optionTitleFontSize} !important;` : ''}
      }
      .cartx-form[data-form-type="input"] > div > .el-input:not(.cartx-b-show-mobile-number) {
        
      }
      .cartx-form[data-form-type="input"] > div > span > .cartx-form-phone-starPhone {
        left: 4px !important;
        top: 53% !important;
        transform: translateY(-50%) !important;
      }
      .cartx-form .el-input__inner {
        border-width: ${rules.inputType === 'bottom' ? '0 0 1px 0' : '1px'}!important;
        border-style: ${rules.inputBorderStyle}!important;
        border-color: ${rules.inputBorderColor}!important;
        border-radius: ${rules.inputBorderRadius}!important;
        background: ${rules.inputBackgroundShow !== 'none' ? rules.inputBackground : 'none'}!important;
        color: ${rules.inputColor}!important;
        ${styleMap['cartx-b-input']['font-family'] ? `font-family: ${styleMap['cartx-b-input']['font-family']} !important;` : ''}
      }
      .cartx-form[data-form-type="input"] input::placeholder {
        color: ${rules.inputColor}!important;
        opacity: .3;
      }
      .cartx-form[data-form-type="input"] input::-webkit-input-placeholder {
        color: ${rules.inputColor}!important;
        opacity: .3;
      }
      .cartx-form[data-form-type="input"] input:-moz-placeholder {
        color: ${rules.inputColor}!important;
        opacity: .3;
      }
      .cartx-form[data-form-type="input"] input::-moz-placeholder {
        color: ${rules.inputColor}!important;
        opacity: .3;
      }
      .cartx-form[data-form-type="input"] input:-ms-input-placeholder {
        color: ${rules.inputColor}!important;
        opacity: .3;
      }
      .cartx-form .cartx-dropdown-select {
        border: none !important;
        background: none !important;
      }
      .cartx-form .cartx-dropdown-select .el-input__inner {
        border-width: 1px !important;
        border-style: ${typeof rules.dropdownBorderStyle !== 'undefined' ? rules.dropdownBorderStyle : 'solid'} !important;
        border-color: ${typeof rules.dropdownBorderColor !== 'undefined' ? rules.dropdownBorderColor : '#C5C4CE'} !important;
        border-radius: ${typeof rules.dropdownBorderRadius !== 'undefined' ? rules.dropdownBorderRadius : '4px'} !important;
        background: ${rules.dropdownBackgroundType !== 'none' ? (typeof rules.dropdownBackgroundColor !== 'undefined' ? rules.dropdownBackgroundColor : '#FFFFFF') : 'none'} !important;
        color: ${typeof rules.dropdownOptionTextColor !== 'undefined' ? rules.dropdownOptionTextColor : '#1d2129'} !important;
      }
      // 下拉菜单占位符颜色独立，透明度与输入框占位符保持一致
      .cartx-dropdown-select input::placeholder {
        color: ${typeof rules.dropdownOptionTextColor !== 'undefined' ? rules.dropdownOptionTextColor : '#1d2129'}!important;
        opacity: .3 !important;
      }
      .cartx-dropdown-select input::-webkit-input-placeholder {
        color: ${typeof rules.dropdownOptionTextColor !== 'undefined' ? rules.dropdownOptionTextColor : '#1d2129'}!important;
        opacity: .3 !important;
      }
      .cartx-dropdown-select input:-moz-placeholder {
        color: ${typeof rules.dropdownOptionTextColor !== 'undefined' ? rules.dropdownOptionTextColor : '#1d2129'}!important;
        opacity: .3 !important;
      }
      .cartx-dropdown-select input::-moz-placeholder {
        color: ${typeof rules.dropdownOptionTextColor !== 'undefined' ? rules.dropdownOptionTextColor : '#1d2129'}!important;
        opacity: .3 !important;
      }
      .cartx-dropdown-select input:-ms-input-placeholder {
        color: ${typeof rules.dropdownOptionTextColor !== 'undefined' ? rules.dropdownOptionTextColor : '#1d2129'}!important;
        opacity: .3 !important;
      }
      .cartx-dropdown-popper .el-select-dropdown__item {
        color: ${typeof rules.dropdownOptionTextColor !== 'undefined' ? rules.dropdownOptionTextColor : '#1d2129'} !important;
      }
      .cartx-form .cartx-question.cartx-dropdown-title {
        line-height: 22px;
        margin-bottom: 8px;
        font-weight: 400;
        ${rules.dropdownTitleColor ? `color: ${rules.dropdownTitleColor} !important;` : ''}
        ${rules.dropdownTitleFontSize ? `font-size: ${rules.dropdownTitleFontSize} !important;` : ''}
        ${rules.dropdownTitleFontFamily ? `font-family: ${rules.dropdownTitleFontFamily} !important;` : ''}
      }

      ${this.enablePrivacySetting ? `
        .cartx-form[data-form-type="privacy"] {
          margin-top: ${styleMap['cartx-b-privacy']['margin-top'] ?? -8}px !important;
          margin-bottom: ${styleMap['cartx-b-privacy']['margin-bottom'] ?? 0}px !important;
          margin-left: ${styleMap['cartx-b-privacy']['margin-left'] ?? 0}px !important;
          margin-right: ${styleMap['cartx-b-privacy']['margin-right'] ?? 0}px !important;
        }
        .cartx-privacy-new-wrapper {
          color: ${styleMap['cartx-b-privacy']['color']} !important;
          background-color: ${styleMap['cartx-b-privacy']['background-color']} !important;
          padding-top: ${styleMap['cartx-b-privacy']['padding-top'] || 0}px !important;
          padding-bottom: ${styleMap['cartx-b-privacy']['padding-bottom'] || 0}px  !important;
          padding-left: ${styleMap['cartx-b-privacy']['padding-left'] || 0}px  !important;
          padding-right: ${styleMap['cartx-b-privacy']['padding-right'] || 0}px  !important;
          min-width: unset !important;
          border-radius: 4px;
          display: flex;
          flex-direction: column;
          align-items: ${textAlignMap[styleMap['cartx-b-privacy']?.['text-align'] || 'left']};
        }
        .cartx-privacy-new-wrapper .cartx-option-columns.cartx-privacy-new {
          padding: 1px 0;
          border-radius: 0;
          background-color: unset;
          margin: 0;
        }
        .cartx-privacy-new-wrapper .cartx-option-columns.cartx-privacy-new {
          max-height: 43px;
        }
        .cartx-option-columns.cartx-privacy-new .tipsSpan {
          font-family: ${styleMap['cartx-b-privacy']['font-family']} !important;
          font-size: ${styleMap['cartx-b-privacy']['font-size']} !important;
        }
        .cartx-option-columns.cartx-privacy-new .el-checkbox__input {
          height: 14px;
        }
        .cartx-option-columns.cartx-privacy-new .el-checkbox__input .el-checkbox__inner,
        .cartx-option-columns.cartx-privacy-new .el-checkbox__input .el-radio__inner {
          border-color: ${styleMap['cartx-b-privacy']['color']} !important;
        }
        .cartx-option-columns.cartx-privacy-new .el-checkbox__input.is-checked .el-checkbox__inner,
        .cartx-option-columns.cartx-privacy-new .el-radio__input.is-checked .el-radio__inner {
          border-color: ${styleMap['cartx-b-privacy-check']['color']} !important;
          background: ${styleMap['cartx-b-privacy-check']['color']} !important;
        }
        .cartx-option-columns.cartx-privacy-new.cartx-privacy-is-check-box .el-checkbox__input {
          top: 1px
        }
        .cartx-option-columns.cartx-privacy-new .el-checkbox__label {
          flex: 1;
        }
      `: ''}
    `;
  }

  get token() {
    return localStorage.getItem('token') || 'default';
  }

  get showLeftRightAdImage() {
    return ['35', '49'].includes(`${Number(this.$route.query.templateid) || this.formData.templateId}`);
  }

  get isPopZhuanpan() {
    const tid = `${Number(this.$route.query.templateid) || this.formData.templateId}`;
    return (
      this.formData.popWindowWheel === POP_WINDOW_WHEEL_TYPE.WHEEL ||
      tid === '36' ||
      tid === '37' ||
      tid === '38' ||
      tid === '39' ||
      tid === '40' ||
      tid === '42' ||
      tid === '43' ||
      `${this.formData.id}` === '1e1609bc024d4517989039886ac7ed34' ||
      `${this.formData.id}` === 'abdac5d809824d8280ffff395a854a15'
    );
  }

  get leftAdImageDisabled() {
    const disabled = this.formDataStart?.settings?.typesetting?.leftAdImage || this.leftAdImageShow;
    return disabled;
  }

  get rightAdImageDisabled() {
    const disabled = this.formDataStart?.settings?.typesetting?.rightAdImage || this.rightAdImageShow;
    return disabled;
  }

  get showDiscountSetting() {
    return sessionStorage.getItem('isShopify') === '1';
    // const company = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    // const companyId = company?.id;
    // return ((companyId === 30 || companyId === 563 || companyId === 565 || companyId === 577 || companyId === 578 || companyId === 579 || companyId === 580 || companyId === 581 || companyId === 582 || companyId === 680 || companyId === 681)) && this.triggerEventType !== 3;
  }

  gaClickFun(key: string, name: string) {
    window?.gtagClick(key, name)
  }

  changeDiscountType() {
    // console.log('changeDiscountType', this.formDataStart.settings.discountType);
    if (this.formDataStart.settings.discountType === 'guding') {
      this.formDataStart.settings.discount = null;
    } else {
      this.showDiscountDialog = true;
    }
    // this.formDataStart.settings.discountType = 'guding';

    // 发送事件通知其他组件
    EventBus.$emit('discount-type-changed', this.formDataStart.settings.discountType);
    this.changeStart();
  }

  showDiscountDialogHandle() {
    this.showDiscountDialog = true;
  }

  saveDiscount(discount: any) {
    this.formDataStart.settings.rules.couponCode = '';
    this.formDataStart.settings.discount = discount;
    this.formDataStart.settings.discountType = 'dongtai';
    // 发送事件通知
    EventBus.$emit('discount-type-changed', 'dongtai');
    this.showDiscountDialog = false;
    this.changeStart();
  }

  closeDiscount() {
    if (this.formDataStart.settings.discountType === 'guding') {
      this.formDataStart.settings.discountType = 'guding';
      this.changeStart();
    }
    this.showDiscountDialog = false;
  }

  changcompontentFormIsShow(e: boolean) {
    this.compontentFormIsShow = e;
  }

  addFormAddList(item: any, index: number) {
    if (this.collapseArr.indexOf('1') < 0) {
      this.collapseArr.push('1');
    }
    if (item.type !== '自定义') {
      let a = this.formList.filter((i: any) => {
        return i.type === item.type;
      });

      if (a.length > 0) {
        this.formType = a[0];
        this.compontentFormIsShow = true;
        return;
      }
      // 检查其他步骤页是否存在相同表单
      let b =
        [
          ...(this.formDataStart.settings.middle || []),
          ...(this.formDataStart.settings.end || [])
        ].filter((i: any) => {
          return i.type === item.type;
        }) || [];
      if (b.length > 0) {
        this.$message.error('您添加了多个' + item.label + '表单，请检查设置是否有误');
        return;
      }
    }

    if (this.formList.length < 8) {
      this.formType = item;
      this.compontentFormIsShow = true;
    } else {
      this.$message.error('最多只能添加8个表单');
    }
    window?.gtagClick('form_edit_selectField_' + item?.label.replace(/\s/g, ''), '弹窗_编辑订阅工具_选择采集项_' + item?.label.replace(/\s/g, ''))
  }

  //倒计时计算
  changecountDownShow() {
    if (this.countdownTime === 'minute') {
      this.formDataStart.settings.rules.countDown = this.countDown * 60;
    } else if (this.countdownTime === 'second') {
      this.formDataStart.settings.rules.countDown = this.countDown;
    }
    // 倒计时关闭，同步关闭分步骤
    if (this.formDataStart.settings.rules.countDownShow) {
      Vue.set(this.formDataStart.settings.rules, 'middleCountDownShow', true);
      Vue.set(this.formDataStart.settings.rules, 'endCountDownShow', true);
    } else {
      Vue.set(this.formDataStart.settings.rules, 'middleCountDownShow', false);
      Vue.set(this.formDataStart.settings.rules, 'endCountDownShow', false);
    }
    window?.gtagClick('form_edit_CountdownTimerEditor', '弹窗_编辑订阅工具_设置倒计时器组件');
    this.ensureExtendedCountdownIfNeeded();
    this.changeStart();
  }

  changeFormList(e: any) {
    this.formDataStart.settings.start = e;
    this.ensureDropdownRuleDefaults();
    if (this.stepDisplayDisabled) {
      Vue.set(this.formDataStart.settings.rules, 'stepDisplay', false);
    }
    this.changeStart();
  }

  changeImgPosition() {
    if (this.formDataStart?.settings?.typesetting?.imgPosition != 'background') {
      this.formDataStart.settings.typesetting.bgbox = false;
    }
    this.changeStart();
  }

  changeStart() {
    console.log('changeStart', this.formDataStart);
    this.$forceUpdate();
    this.$emit('change', this.formDataStart);
    window?.gtagClick('form_edit_setCloseButton', '弹窗_编辑订阅工具_设置关闭按钮')
  }
  changeStartGA() {
    this.$forceUpdate();
    this.$emit('change', this.formDataStart);
    window?.gtagClick('form_edit_setCloseButton', '弹窗_编辑订阅工具_设置关闭按钮')
  }

  changeStartWithGtag(key: string, name: string) {
    this.$forceUpdate();
    this.$emit('change', this.formDataStart);
    window?.gtagClick(key, name);
  }

  changeOptionFontFamily(val: string) {
    this.$set(this.formDataStart.settings.rules as any, 'optionFontFamily', val);
    this.changeStartWithGtag('form_edit_selectField_option_font', '弹窗_编辑订阅工具_选择采集项_选项_字体');
  }

  ensureDropdownRuleDefaults() {
    const rules = this.formDataStart?.settings?.rules as any;
    if (!rules) return;
    if (!this.formList.some((item: any) => item.type === '自定义' && item.questionType === 'Dropdown')) return;
    const defaults = {
      dropdownTitleColor: '#1D2129',
      dropdownTitleFontSize: '16px',
      dropdownTitleFontFamily: 'Arial, sans-serif',
      dropdownBorderStyle: 'solid',
      dropdownBorderColor: '#C5C4CE',
      dropdownBorderRadius: '4px',
      dropdownBackgroundType: '',
      dropdownBackgroundColor: '#FFFFFF',
      dropdownOptionTextColor: '#1d2129'
    };
    Object.keys(defaults).forEach((key) => {
      if (typeof rules[key] === 'undefined') {
        this.$set(rules, key, defaults[key]);
      }
    });
  }

  ensureInputMarginRuleDefaults() {
    const rules = this.formDataStart?.settings?.rules as any;
    if (!rules) return;
    const defaults = {
      inputMarginTop: 0,
      inputMarginLeft: 0,
      inputMarginBottom: 14,
      inputMarginRight: 0,
      optionMarginTop: 0,
      optionMarginLeft: 0,
      optionMarginBottom: 14,
      optionMarginRight: 0,
      dropdownMarginTop: 0,
      dropdownMarginLeft: 0,
      dropdownMarginBottom: 14,
      dropdownMarginRight: 0
    };
    Object.keys(defaults).forEach((key) => {
      if (typeof rules[key] === 'undefined') {
        this.$set(rules, key, defaults[key]);
      }
    });
  }

  changeCouponCodePosition() {
    if (this.couponCodeShow) {
      if (this.formData.settings.rules.couponCodePosition === 'end') {
        this.$message.warning('结束页面已经展示coupon');
        this.couponCodeShow = false;
      } else {
        this.formDataStart.settings.rules.couponCodePosition = 'start';
        this.formDataStart.settings.rules.couponCodeShow = this.couponCodeShow;
      }
    } else {
      if (this.formData.settings.rules.couponCodePosition === 'end') {
        this.formDataStart.settings.rules.couponCodePosition = 'end';
      } else {
        this.formDataStart.settings.rules.couponCodePosition = '';
      }
    }
    this.changeStart();
  }

  changeCouponCodeType() {
    this.changeStart();
  }

  blurPointDeg() {
    if (!this.formDataStart.settings.rules.pointFinallyDeg) {
      this.formDataStart.settings.rules.pointFinallyDeg = 0;

      const input = document.querySelector('.wheel-setting-deg-input input');
      if (input) {
        input.value = '0';
      }
    }
  }

  changePointDeg() {
    if (!this.formDataStart.settings.rules.pointFinallyDeg) {
      this.formDataStart.settings.rules.pointFinallyDeg = 0;

      const input = document.querySelector('.wheel-setting-deg-input input');
      if (input) {
        input.value = '0';
      }
    }
    this.changeStart();
  }

  get stepDisplayDisabled() {
    return !isEmailPhoneStepForm(this.formData.settings.start || [], this.formData.settings.end);
  }

  // 当开始页按钮交互切换为“显示下一步骤”或其他选项时，更新页面设置
  handleButtonActionChange() {
    const action = this.formDataStart?.settings?.rules?.buttonAction;

    if (action === 'sms') {
      window?.gtagClick('form_edit_btnActionSmsSub', '弹窗_编辑订阅工具_设置按钮交互为通过短信订阅');
      if (typeof this.formDataStart.settings.rules.smsSubBody === 'undefined') {
        this.$set(
          this.formDataStart.settings.rules as any,
          'smsSubBody',
          'Send this text to subscribe to recurring automated personalized marketing alerts (e.g. cart reminders) from XXXX'
        );
      }
      if (typeof this.formDataStart.settings.rules.breakSmsDoubleCheck === 'undefined') {
        this.$set(this.formDataStart.settings.rules as any, 'breakSmsDoubleCheck', true);
      }
    } else if (action === 'open') {
      this.pageSettings.forEach((item: any) => {
        if (item.value === 'end') {
          // 启用结束页：恢复不透明度
          item.opacity = 1;
        }
      });
    } else {
      this.pageSettings.forEach((item: any) => {
        if (item.value === 'end') {
          // 禁用结束页：降低不透明度
          item.opacity = 0.3;
        }
      });
    }

    this.changeStart();
  }

  @Watch('formData.settings.typesetting.imgUrl', { immediate: true })
  typesettingImgUrlChange(val: string) {
    if (val) {
      this.bgUploadShow = true;
      this.bgUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }
  @Watch('formData.settings.typesetting.bgImgUrl', { immediate: true })
  typesettingBGImgUrlChange(val: string) {
    const wheelImgUrl = this.formData?.settings?.typesetting?.wheelImgUrl;
    const finalUrl = wheelImgUrl || val;
    if (finalUrl) {
      this.zpbgUploadShow = true;
      this.zpbgUploadFileList = [
        {
          name: '',
          url: finalUrl
        }
      ];
    }
  }
  @Watch('formData.settings.typesetting.wheelImgUrl', { immediate: true })
  typesettingWheelImgUrlChange(val: string) {
    if (val) {
      this.zpbgUploadShow = true;
      this.zpbgUploadFileList = [{ name: '', url: val }];
    }
  }
  @Watch('formData.settings.typesetting.pointImgUrl', { immediate: true })
  typesettingPointImgUrlChange(val: string) {
    if (val) {
      this.pointUploadShow = true;
      this.pointUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }

  @Watch('formData.settings.logo.imgUrl', { immediate: true })
  logoImgUrlChange(val: string) {
    if (val) {
      this.logoUploadShow = true;
      this.logoUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }

  @Watch('formData.settings.typesetting.leftAdImage', { immediate: true })
  leftAdImageUrlChange(val: string) {
    if (val) {
      this.leftAdImageShow = true;
      this.leftAdImageFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }

  @Watch('formData.settings.typesetting.rightAdImage', { immediate: true })
  rightAdImageUrlChange(val: string) {
    if (val) {
      this.rightAdImageShow = true;
      this.rightAdImageFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }

  @Watch('formData.settings.texts.textAreaImgUrl', { immediate: true })
  textAreaImgUrlChange(val: string) {
    if (val) {
      this.textAreaUploadShow = true;
      this.textAreaFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }

  @Watch('formData.settings.rules.emailOpen')
  emailOpenChange(val: boolean) {
    if (val === true && this.formData.settings.rules.emailPosition === 'start') {
      this.emailOpen = true;
    } else {
      this.emailOpen = false;
      if (this.formData.settings.rules.emailPosition === 'end') {
        this.formDataStart.settings.rules.emailPosition = 'end';
      } else {
        this.formDataStart.settings.rules.emailPosition = '';
      }
    }
  }

  @Watch('formData.settings.rules.emailPosition')
  emailPositionChange(val: string) {
    this.emailOpen = this.formData.settings.rules.emailOpen === true && val === 'start';
  }

  @Watch('formData.settings.rules.couponCodeShow')
  couponCodeShowChange(val: boolean) {
    this.couponCodeShow = val === true && this.formData.settings.rules.couponCodePosition === 'start';
  }

  @Watch('formData.settings.rules.couponCodePosition')
  couponCodePositionChange(val: string) {
    this.couponCodeShow = this.formData.settings.rules.couponCodeShow === true && val === 'start';
  }

  mounted() {
    this.ensureInputMarginRuleDefaults();
    this.ensureDropdownRuleDefaults();
    this.ensureTieredDiscountButtonAction();
    if (!!this.formDataStart.settings.rules.couponCode || !this.formDataStart.settings.discount) {
      this.formDataStart.settings.discountType = 'guding';
    } else {
      this.formDataStart.settings.discountType = 'dongtai';
    }

    // 设置移动端广告位比例默认值
    if (!this.formDataStart.settings.rules.mobileRatio && this.enableMobileRatio) {
      this.formDataStart.settings.rules.mobileRatio = 'recommendRatio';
    }
    if (typeof this.formDataStart?.settings?.rules?.mobilePictureShow === 'undefined') {
      this.$set(this.formDataStart.settings.rules, 'mobilePictureShow', false);
    }

    // 确保 authList 存在
    if (!this.formDataStart.settings.authList) {
      this.$set(this.formDataStart.settings, 'authList', []);
    }

    // 加载素材库列表 - 按 category 筛选
    Promise.all([
      getImageList({ category: 'background' }),
      getImageList({ category: 'wheel' }),
      getImageList({ category: 'pointer' })
    ]).then((res: any) => {
      this.backgroundImageList = res[0]?.data?.data || [];
      this.wheelImageList = res[1]?.data?.data || [];
      this.pointerImageList = res[2]?.data?.data || [];
    });

    if (Number(this.formDataStart.popWindowWheel) === 2) {
      const typesetting = this.formDataStart?.settings?.typesetting;
      if (this.formDataStart?.settings?.rules) {
        this.formDataStart.settings.rules.buttonAction = 'open';
        this.formDataStart.settings.rules.mobilePictureShow = false;
      }
      if (typesetting) {
        // 图片位置支持切换左/右；转盘固定在内容区，由左右布局自行决定显示在左还是右。
        if (!['left', 'right'].includes(typesetting.imgPosition)) {
          typesetting.imgPosition = 'right';
        }
        typesetting.wheelPosition = typesetting.wheelPosition || 'top';
        // 兼容旧数据：新字段为空时，回填已有的 bgImgUrl
        typesetting.wheelImgUrl = typesetting.wheelImgUrl || typesetting.bgImgUrl;
        typesetting.pointImgPosition = typesetting.pointImgPosition || 'middle';
      }
    }
    this.ensureExtendedCountdownIfNeeded();
  }

  @Watch('formDataStart.settings.rules.countDownShow', { immediate: true })
  onCountDownShowForExtended() {
    this.ensureExtendedCountdownIfNeeded();
  }

  @Watch('formData')
  changeFormData() {
    this.formDataStart = this.formData;
    this.ensureInputMarginRuleDefaults();
    this.ensureDropdownRuleDefaults();
    this.ensureTieredDiscountButtonAction();
    // if (!this.formDataStart.settings.discountType) {
    if (!!this.formDataStart.settings.rules.couponCode || !this.formDataStart.settings.discount) {
      this.formDataStart.settings.discountType = 'guding';
    } else {
      this.formDataStart.settings.discountType = 'dongtai';
    }

    // 设置移动端广告位比例默认值
    if (!this.formDataStart.settings.rules.mobileRatio && this.enableMobileRatio) {
      this.formDataStart.settings.rules.mobileRatio = 'recommendRatio';
    }
    if (typeof this.formDataStart?.settings?.rules?.mobilePictureShow === 'undefined') {
      this.$set(this.formDataStart.settings.rules, 'mobilePictureShow', false);
    }
    if (Number(this.formDataStart.popWindowWheel) === 2 && this.formDataStart?.settings?.typesetting) {
      if (this.formDataStart?.settings?.rules) {
        this.formDataStart.settings.rules.buttonAction = 'open';
        this.formDataStart.settings.rules.mobilePictureShow = false;
      }
      const typesetting = this.formDataStart.settings.typesetting;
      typesetting.wheelPosition = typesetting.wheelPosition || 'top';
      typesetting.wheelImgUrl = typesetting.wheelImgUrl || typesetting.bgImgUrl;
      if (!['left', 'right'].includes(typesetting.imgPosition)) {
        typesetting.imgPosition = 'right';
      }
      typesetting.pointImgPosition = typesetting.pointImgPosition || 'middle';
    }
    this.ensureExtendedCountdownIfNeeded();
    // }
  }
  @Watch('formData.settings.rules.countDown')
  changeCountDown(val: number) {
    const n = Math.floor(Number(val) || 0);
    if (n > 60 && n % 60 === 0) {
      this.countDown = n / 60;
      this.countdownTime = 'minute';
    } else if (n === 60) {
      this.countdownTime = 'second';
      this.$nextTick(() => {
        this.countDown = 60 / 1;
      });
    } else {
      this.countdownTime = 'second';
      this.countDown = n;
    }
  }

  @Watch('formData.settings.start')
  changeStartFormList(val: any) {
    this.formList = val;
    this.ensureDropdownRuleDefaults();
  }

  @Watch('formData.settings.rules.privacyPosition')
  privacyPositionChange(val: string) {
    const styleMap = this.formDataStart.settings.styles.styleMap['cartx-b-privacy'];
    // 嵌入弹窗都在button下面
    if (val === 'form' && this.formDataStart.triggerEventType !== 7) {
      // 跟随采集框：下间距6px，上间距0
      styleMap['margin-bottom'] = 6;
      styleMap['margin-top'] = 0;
    } else if (val === 'button' || this.formDataStart.triggerEventType === 7) {
      // 主按钮以下：下间距0，上间距6px
      styleMap['margin-bottom'] = 0;
      styleMap['margin-top'] = 6;
    }
  }

  /**
   * 图片上传失败钩子函数
   */
  bgHandleError(e: any): void {
    this.bgUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  bgHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.bgUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.imgUrl = res.data[0].url);
      this.bgUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.bgUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  bgBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE =
      file.type === "image/jpeg" ||
      file.type === "image/gif" ||
      file.type === "image/webp" ||
      file.type === "image/png" ||
      file.type === "image/jpg";
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.bgUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  bgUploadUrlDelete() {
    this.bgUploadShow = false;
    this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.imgUrl = '');
  }

  /**
   * 图片上传失败钩子函数
   */
  zpbgHandleError(e: any): void {
    this.zpbgUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  zpbgHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.zpbgUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      if (this.formDataStart?.settings?.typesetting) {
        // 新模板提交字段使用 wheelImgUrl，同时保留 bgImgUrl 兼容旧渲染逻辑。
        this.formDataStart.settings.typesetting.wheelImgUrl = res.data[0].url;
        this.formDataStart.settings.typesetting.bgImgUrl = res.data[0].url;
      }
      this.zpbgUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.zpbgUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  zpbgBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png' || file.type === 'image/jpg';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.zpbgUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  zpbgUploadUrlDelete() {
    this.zpbgUploadShow = false;
    if (this.formDataStart?.settings?.typesetting) {
      this.formDataStart.settings.typesetting.wheelImgUrl = '';
      this.formDataStart.settings.typesetting.bgImgUrl = '';
    }
  }

  /**
   * 图片上传失败钩子函数
   */
  pointHandleError(e: any): void {
    this.pointUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  pointHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.pointUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      const typesetting = this.formDataStart?.settings?.typesetting;
      if (typesetting) {
        typesetting.pointImgUrl = res.data[0].url;
        // mode2 下指针落位需要该字段；若后端未返回，则默认 middle
        if (Number(this.formDataStart.popWindowWheel) === 2) {
          typesetting.pointImgPosition = typesetting.pointImgPosition || 'middle';
        }
      }
      this.pointUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.pointUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  pointBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.pointUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  pointUploadUrlDelete() {
    this.pointUploadShow = false;
    this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.pointImgUrl = '');
  }

  /**
   * 图片上传失败钩子函数
   */
  logoHandleError(e: any): void {
    this.logoUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  logoHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.logoUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.logo && (this.formDataStart.settings.logo.imgUrl = res.data[0].url);
      this.logoUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.logoUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  logoBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.logoUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  logoUploadUrlDelete() {
    this.logoUploadShow = false;
    this.formDataStart?.settings?.logo && (this.formDataStart.settings.logo.imgUrl = '');
  }

  // 左图上传

  /**
   * 图片上传失败钩子函数
   */
  leftAdImageHandleError(e: any): void {
    this.leftAdImageShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  leftAdImageHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.leftAdImageShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.leftAdImage = res.data[0].url);
      this.leftAdImageFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.leftAdImageShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  leftAdImageBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.leftAdImageShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  leftAdImageUrlDelete() {
    this.leftAdImageShow = false;
    this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.leftAdImage = '');
    this.changeStart();
  }

  // 右图上传

  /**
   * 图片上传失败钩子函数
   */
  rightAdImageHandleError(e: any): void {
    this.rightAdImageShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  rightAdImageHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.rightAdImageShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.rightAdImage = res.data[0].url);
      this.rightAdImageFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.rightAdImageShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  rightAdImageBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.rightAdImageShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  rightAdImageUrlDelete() {
    this.rightAdImageShow = false;
    this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.rightAdImage = '');
    this.changeStart();
  }

  uploadUrlPreview(file: any) {
    this.uploadDialogUrl = file.url;
    this.uploadDialogVisible = true;
  }

  /**
   * 图片上传失败钩子函数
   */
  textAreaHandleError(e: any): void {
    this.textAreaUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  textAreaHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.textAreaUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      if (this.formDataStart?.settings?.texts) {
        // 使用 Vue.set / this.$set 确保 textAreaImgUrl 响应式，触发 popNew 重新渲染
        this.$set(this.formDataStart.settings.texts as any, 'textAreaImgUrl', res.data[0].url);
      }
      this.textAreaFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.textAreaUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  textAreaBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.textAreaUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  textAreaUploadUrlDelete() {
    this.textAreaUploadShow = false;
    if (this.formDataStart?.settings?.texts) {
      // 删除时同样用 this.$set，保证值变更是响应式的
      this.$set(this.formDataStart.settings.texts as any, 'textAreaImgUrl', '');
    }
    this.changeStart();
  }
  /**
   * 点击上传图片
   */
  textAreaClick() {
    window.gtagClick('form_edit_setTextImage', '弹窗_编辑订阅工具_设置文本区域图片');
  }

  /**
   * 检查某个登录方式是否已启用
   */
  isAuthEnabled(type: number): boolean {
    return this.formDataStart.settings.authList?.some(auth => auth.type === type) || false;
  }

  /**
   * 获取某个登录方式的 clientId
   */
  getAuthClientId(type: number): string {
    return this.formDataStart.settings.authList?.find(auth => auth.type === type)?.clientId || '';
  }

  /**
   * 切换登录方式启用状态
   */
  toggleAuthProvider(type: number, enabled: boolean) {
    if (!this.formDataStart.settings.authList) {
      this.$set(this.formDataStart.settings, 'authList', []);
    }

    if (enabled) {
      // 启用：添加到 authList
      if (!this.isAuthEnabled(type) && this.formDataStart.settings.authList) {
        this.formDataStart.settings.authList.push({
          type: type,
          clientId: ''
        });
      }
    } else {
      // 禁用：从 authList 中移除
      if (this.formDataStart.settings.authList) {
        const index = this.formDataStart.settings.authList.findIndex(auth => auth.type === type);
        if (index > -1) {
          this.formDataStart.settings.authList.splice(index, 1);
        }
      }
    }

    window.gtagClick('form_edit_signinwithGoogle', '弹窗_编辑订阅工具勾选google登录');
    this.changeStart();
  }

  /**
   * 更新 clientId
   */
  updateAuthClientId(type: number, clientId: string) {
    if (!this.formDataStart.settings.authList) {
      return;
    }
    const auth = this.formDataStart.settings.authList.find(auth => auth.type === type);
    if (auth) {
      auth.clientId = clientId;
      this.changeStart();
    }
  }

  /**
   * 校验 Google Client ID 格式
   * 只校验结尾是否为 .apps.googleusercontent.com
   */
  isValidGoogleClientId(clientId: string): boolean {
    return clientId.trim().endsWith('.apps.googleusercontent.com');
  }

  /**
   * 校验第三方登录配置
   * 如果启用了第三方登录，需要校验：
   * 1. clientId 是否已填写
   * 2. clientId 格式是否正确
   * 3. 是否有 email 采集项
   */
  validateAuthList(): boolean {
    if (!this.formDataStart.settings.authList || this.formDataStart.settings.authList.length === 0) {
      return true; // 没有启用第三方登录，校验通过
    }

    // 校验每个启用的第三方登录
    for (const auth of this.formDataStart.settings.authList) {
      // 1. 校验 clientId 是否已填写
      if (!auth.clientId || auth.clientId.trim() === '') {
        this.$message.error({
          message: '您已勾选添加第三方登录按钮，请输入Google client ID，再进行下一步操作',
          type: 'error',
          duration: 5000
        });
        return false;
      }

      // 2. 校验 clientId 格式是否正确
      if (!this.isValidGoogleClientId(auth.clientId)) {
        this.$message.error({
          message: 'Google Client ID 格式不正确，应为：xxx.apps.googleusercontent.com',
          type: 'error',
          duration: 5000
        });
        return false;
      }

      // 3. 校验是否有 email 采集项
      const hasEmail = this.formList.some((form: any) => form.type === 'Email');
      if (!hasEmail) {
        this.$message.error({
          message: '您已勾选添加第三方登录按钮，请添加Email表单后，再进行下一步操作',
          type: 'error',
          duration: 5000
        });
        return false;
      }
    }

    return true;
  }
}
